import React, { useEffect } from 'react';
import { Container, Typography, Box, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Authentication from '../components/Authentication';
import { useAppSelector } from '../store/hooks';

const Home = () => {
  const config = window.runtimeConfig || {};
  const theme = useTheme();
  const navigate = useNavigate();
  const { isValid, operator } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (isValid && operator) {
      navigate('/predictor');
    }
  }, [isValid, operator, navigate]);

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 80px)',
        background:
          theme.palette.mode === 'dark'
            ? 'linear-gradient(180deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)'
            : 'linear-gradient(180deg, #f5f7fa 0%, #c3cfe2 100%)',
        color:
          theme.palette.mode === 'dark' ? 'white' : theme.palette.text.primary,
        py: 4,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            theme.palette.mode === 'dark'
              ? 'radial-gradient(circle at 20% 50%, rgba(25, 118, 210, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(156, 39, 176, 0.1) 0%, transparent 50%)'
              : 'radial-gradient(circle at 20% 50%, rgba(25, 118, 210, 0.05) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(156, 39, 176, 0.05) 0%, transparent 50%)',
          pointerEvents: 'none',
        },
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography
            variant="h1"
            sx={{
              color:
                theme.palette.mode === 'dark'
                  ? 'white'
                  : theme.palette.text.primary,
              textShadow:
                theme.palette.mode === 'dark'
                  ? '2px 2px 4px rgba(0, 0, 0, 0.3)'
                  : 'none',
              mb: 2,
              fontWeight: 600,
            }}
          >
            Welcome to Service Availability Predictor
          </Typography>
          <Typography
            variant="h5"
            sx={{
              opacity: theme.palette.mode === 'dark' ? 0.9 : 0.8,
              mb: 4,
              color:
                theme.palette.mode === 'dark'
                  ? 'white'
                  : theme.palette.text.secondary,
            }}
          >
            Predict and analyze service availability for your network
            infrastructure
          </Typography>
        </Box>

        <Authentication />
      </Container>
    </Box>
  );
};

export default Home;
